/**
 * Language Selector Widget
 *
 * Renders language selector from backend definition.
 * Backend provides list of languages with codes and labels.
 */

import React, { useState } from 'react';
import type { WidgetProps } from './registry';
import './LanguageSelector.css';

export const LanguageSelectorWidget: React.FC<WidgetProps> = ({
  widget,
  onChange,
}) => {
  const {
    options = [],
    value: initialValue,
    name = 'language',
    css_style,
  } = widget;

  const [selectedLang, setSelectedLang] = useState(
    initialValue || options[0]?.code || 'en'
  );

  const handleLanguageChange = (code: string) => {
    setSelectedLang(code);
    onChange?.(name, code);
  };

  return (
    <div className="rul-widget-language-selector" style={css_style}>
      {options.map((lang: any) => (
        <button
          key={lang.code}
          type="button"
          className={`rul-lang-btn ${selectedLang === lang.code ? 'active' : ''}`}
          onClick={() => handleLanguageChange(lang.code)}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};
